export default "__VITE_ASSET___gkecK9i__"